<div class="otp-dialog">

    <!-- Type selection screen -->
    <ng-container *ngIf="!type">
        <div class="dialog-header">
            <div class="shield-icon">
                <i class="fa fa-shield"></i>
            </div>
            <div class="dialog-title">Additional Verification Required</div>
            <div class="dialog-subtitle">Please select how you would like to verify your identity</div>
        </div>

        <div class="dialog-body">
            <div class="type-buttons">
                <button class="btn-type" [disabled]="isSendingSms" (click)="setSmsType()">
                    <i class="fa fa-commenting type-icon"></i>
                    <div class="type-label">
                        <strong>{{ isSendingSms ? 'Sending code...' : 'Text me a code' }}</strong>
                        <span>Receive a code via SMS</span>
                    </div>
                </button>
                <button class="btn-type" [disabled]="isSendingSms" (click)="setGoogleType()">
                    <i class="fa fa-lock type-icon"></i>
                    <div class="type-label">
                        <strong>Authenticator app</strong>
                        <span>Use your authenticator app</span>
                    </div>
                </button>
            </div>
        </div>

        <div class="dialog-footer">
            <button class="btn-cancel" mat-dialog-close>Cancel</button>
        </div>
    </ng-container>

    <!-- OTP entry screen -->
    <ng-container *ngIf="type">
        <div class="dialog-header">
            <div class="shield-icon">
                <i class="fa fa-shield"></i>
            </div>
            <div class="dialog-title">Additional Verification Required</div>
            <div class="dialog-subtitle">{{ subtitle }}</div>
        </div>

        <div class="dialog-body">
            <!-- OTP cells (shared control) -->
            <app-otp-code-input
                    [disabled]="isSubmitting || isSuccess"
                    [error]="hasError"
                    [success]="isSuccess"
                    (valueChange)="onCodeChange($event)"
                    (completed)="submit($event)"></app-otp-code-input>

            <div class="otp-hint" [class.otp-hint-error]="hasError" [class.otp-hint-success]="isSuccess">
                <ng-container *ngIf="hasError">Incorrect code — please try again</ng-container>
                <ng-container *ngIf="isSuccess">Verified! Logging you in...</ng-container>
                <ng-container *ngIf="isSubmitting && !hasError && !isSuccess">Verifying...</ng-container>
                <ng-container *ngIf="!hasError && !isSuccess && !isSubmitting">{{ code.length }} of 6 digits entered</ng-container>
            </div>

            <div *ngIf="showTrustDevice" class="divider"></div>

            <!-- Trust checkbox -->
            <label *ngIf="showTrustDevice" class="checkbox-row">
                <div class="checkbox-wrap">
                    <input type="checkbox" class="checkbox-input" [(ngModel)]="trustDevice">
                </div>
                <div class="checkbox-label">
                    <strong>Trust this browser</strong>
                    <span>Don't ask for a code again on this browser for 30 days. Only use on personal devices.</span>
                </div>
            </label>
        </div>

        <div class="dialog-footer">
            <button class="btn-verify"
                    [class.btn-loading]="isSubmitting"
                    [class.btn-success]="isSuccess"
                    [disabled]="code.length < 6 || isSubmitting || isSuccess"
                    (click)="submit(code)">
                <ng-container *ngIf="isSubmitting && !isSuccess">
                    <i class="fa fa-spinner fa-spin"></i> Verifying...
                </ng-container>
                <ng-container *ngIf="isSuccess">
                    <i class="fa fa-check"></i> Verified
                </ng-container>
                <ng-container *ngIf="!isSubmitting && !isSuccess">
                    Verify
                </ng-container>
            </button>
            <button class="btn-cancel" *ngIf="canGoBack" (click)="goBack()">
                <i class="fa fa-arrow-left"></i> Back
            </button>
            <button class="btn-cancel" *ngIf="!canGoBack" mat-dialog-close>
                Cancel
            </button>
        </div>
    </ng-container>

</div>
